import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_workspace_update } from '@/state/workspace/entity/remote_workspace_update';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function WSCheckboxNotifyOwnerAboutReachingCreditLimit() {
  const dispatch = use_dispatch();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const [inProgress, setInProgress] = useState(false);

  async function onCheckedChange() {
    let workspace_new = workspace_current.clone({ notify_owner_about_reaching_credits_limit: !workspace_current.notify_owner_about_reaching_credits_limit });

    setInProgress(true);
    await dispatch(remote_workspace_update(workspace_new));
    setInProgress(false);
  }

  function is_disabled(): boolean {
    return inProgress;
  }

  return (
    <div className="flex items-center mt-2">
      <UI_PRIMITIVE__checkbox
        id="WSCheckboxNotifyOwnerAboutReachingCreditLimit"
        disabled={is_disabled()}
        checked={workspace_current.notify_owner_about_reaching_credits_limit}
        onCheckedChange={onCheckedChange}
      />
      <label
        htmlFor="WSCheckboxNotifyOwnerAboutReachingCreditLimit"
        className={`ml-2 text-sm cursor-pointer ${workspace_current.notify_owner_about_reaching_credits_limit ? '' : 'opacity-50 '}`}
      >
        {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_limit.checkbox.reaching_credits_limit)}
      </label>
    </div>
  );
}
